import { createTheme } from "./utils";
const baseTheme = createTheme({
  primary: "#420fe7",
  secondary: "red",
  textBase: "yellow"
});
export default baseTheme;